import styled from 'styled-components'

import ArrowCircleRightIcon from '../icons/ArrowCircleRightIcon'
import List from '../basic-components/List'
import ListItem from '../basic-components/ListItem'

const Span = styled.span`
  pointer-events: none;
`

export default function Menu({ items, onItemClick }) {
  return (
    <List>
      {items.map((item) => (
          <ListItem key={item.text} onClick={onItemClick} >
            <div style={{flex: 1}}>{item.text}</div>
              <Span>
                <ArrowCircleRightIcon
                  style={{pointerEvents: 'none'}}
                />
              </Span>
          </ListItem>
      ))}
    </List>
  )
}
